module.exports = __webpack_public_path__ + "static/media/icon-agilidade.d6d66961.svg";